export * from '@fhs/routing/src/routes/[staticPage]/index';
export { default } from '@fhs/routing/src/routes/[staticPage]/index';
